export const errorText = (err, fallback) =>
  err?.response?.data?.message || err?.response?.data?.error || fallback;
